import $ from "jquery";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";

window.jQuery = $;
require("@fancyapps/fancybox");

export const createGallery = () => {
	// Create gallery function
	let galleryid = 0;

	$(".gallery").each(function (a, b) {
		const images = $(this).find("img");
		images.addClass("gallery-image").wrap(() => "<a class='gallery-image-link'>");

		images.parent("a").attr({
			"data-fancybox": "group",
			"data-caption": function () {
				let caption = $(this).children("img").attr("longdesc");
				if (typeof caption === "undefined") {
					caption = $(this).children("img").attr("longdesc");
				}
				return caption;
			},
			rel: `gallery_${galleryid}`,
			href: function () {
				return $(this).children("img").attr("data-src");
			},
			title: function () {
				let title = $(this).children("img").attr("title");
				if (typeof title === "undefined") {
					title = $(this).children("img").attr("alt");
				}
				return title;
			},
		});

		galleryid++;
	});
};

export const createCarousel = () => {
	let carouselid = 0;

	$(".gallery > .gallery-content").each(function (a, b) {
		const images = $(this).find("img");
		images.addClass("gallery-image").wrap(() => "<div class='f-carousel__slide'>");

		images.parent("div").attr({
			"data-fancybox": "group",
			rel: `gallery_${carouselid}`,
			href: function () {
				return $(this).children("img").attr("data-src");
			},
			title: function () {
				let title = $(this).children("img").attr("title");
				if (typeof title === "undefined") {
					title = $(this).children("img").attr("alt");
				}
				return title;
			},
		});
		this.id = `gallery_${carouselid}`;
		this.classList.remove("gallery-content");
		this.classList.add("carousel-content");
		carouselid++;

		const container = document.getElementById(this.id);
		const options = {
			Dots: false,
			slidesPerPage: 1,
		};
		_ = new Carousel(container, options);
	});
};
